// VERSION 1.0.0
// AUTHOR: AGALYA

import { docodeHexResponse } from '../../_common/common.utils';
import CommonTransferLogActionTypes from './common-transfer-log.types';

const INITIAL_STATE = {
	// Fetch Transfer Log
	fetchTransferLogListResponse: null,
	fetchTransferLogListArr: [],

	// Get Member Approved List
	getMemberApproveListResponse: null,
	getMemberApproveListArr: [],

	// Change status transfer log
	changeStatusTransferLogResp: null,

	// Get member for transfer center
	getMemberForTransferCenterListResp: null,
	getMemberForTransferCenterListArr: [],
};

const commonTransferLogReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** FETCH TRANSFER LOG START  ******************/
		case CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_SUCCESS:
			return {
				...state,
				fetchTransferLogListResponse: action.payload,
				fetchTransferLogListArr: docodeHexResponse(action.payload, 'FetchTransferLogKey'),
			};

		case CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_FAILURE:
			return {
				...state,
				fetchTransferLogListResponse: action.payload,
				fetchTransferLogListArr: [],
			};

		case CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_RESPONSE_CHANGED:
			return { ...state, fetchTransferLogListResponse: null };

		/*************** FETCH TRANSFER LOG END  ******************/

		/***************  GET MEMBER APPROVE LIST START  ******************/
		case CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_SUCCESS:
			return {
				...state,
				getMemberApproveListResponse: action.payload,
				getMemberApproveListArr: docodeHexResponse(
					action.payload,
					'GetMemberApproveListKey',
				),
			};

		case CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_FAILURE:
			return {
				...state,
				getMemberApproveListResponse: action.payload,
				getMemberApproveListArr: [],
			};

		case CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_RESPONSE_CHANGED:
			return { ...state, getMemberApproveListResponse: null };

		/***************  GET MEMBER APPROVE LIST END  ******************/

		/***************  CHANGE STATUS TRANSFER LOG START ******************/
		case CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_SUCCESS:
			return {
				...state,
				changeStatusTransferLogResp: action.payload,
			};

		case CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_FAILURE:
			return {
				...state,
				changeStatusTransferLogResp: action.payload,
			};

		case CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_RESPONSE_CHANGED:
			return { ...state, changeStatusTransferLogResp: null };

		/***************  CHANGE STATUS TRANSFER LOG END ******************/

		/*********  MEMBER FOR TRANSFER CENTER START *********/
		case CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_SUCCESS:
			return {
				...state,
				getMemberForTransferCenterListResp: action.payload,
				getMemberForTransferCenterListArr: docodeHexResponse(
					action.payload,
					'GetMemberForTransferCenterKey',
				),
			};

		case CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_FAILURE:
			return {
				...state,
				getMemberForTransferCenterListResp: action.payload,
				getMemberForTransferCenterListArr: [],
			};

		case CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_RESPONSE_CHANGED:
			return { ...state, getMemberForTransferCenterListResp: null };

		/*********  MEMBER FOR TRANSFER CENTER END *********/

		default:
			return state;
	}
};

export default commonTransferLogReducer;
